import React, { useEffect, useState } from "react";
import { getVoluntaryPGAData } from "../../../../CBP_App/api/getEntrySummaryData";
import { DropDown } from '../../../../commonComponents/dropDownCommon'
import { pgaHumanNames } from "../../../../CBP_App/formSections/pga/constantsPGA";
const VoluntryPgas = ({pgaDropdownOnChange, applicableProgramNames, pgaWithoutPgaItems, formDisabled}) => {
    const [voluntaryPgaData, setVoluntaryPgaData] = useState([]);
    const [volPgaDropDownVal, setVolPgaDropDownVal] = useState("");
    const [open, setOpen] = useState(false);

    const getVoluntaryPgaDropdownData = async ()=>{
        const response = await getVoluntaryPGAData();
        if(response.data.eventMessage.pgaMetadataList){
            
            let pgaDropdownValues = {};
            response.data.eventMessage.pgaMetadataList.map((item)=>{
                if(!applicableProgramNames.includes(item.programName)){
                
                    if(!pgaDropdownValues[item.programName]){
                        pgaDropdownValues[item.programName] = []
                    }
                    item.programDetails.map((program)=>{
                        if(!pgaDropdownValues[item.programName].includes(program.formType)){
                            pgaDropdownValues[item.programName].push(program.formType);
                        }
                    });
                }
            })
            let dropdownVal = [{description: "Add Voluntary PGA", value:"__BLANK__"}];
            Object.entries(pgaDropdownValues).map(([key, value])=>{
                value.map((item)=>{
                    dropdownVal.push({description: `${item} - ${pgaHumanNames[item]}`, value: {value:item, programName:key, isManuallyAddedPga:"true"}});
                });
            })
            setVoluntaryPgaData(dropdownVal);
        }
    }
    useEffect(()=>{
        if(voluntaryPgaData.length === 0)
            getVoluntaryPgaDropdownData();
        // if(pgaWithoutPgaItems.length > 0 && pgaWithoutPgaItems[0] !== volPgaDropDownVal){
        //     setVolPgaDropDownVal(pgaWithoutPgaItems[0]);
        // }
    }, [applicableProgramNames, pgaWithoutPgaItems])

    useEffect(()=>{
        if(pgaWithoutPgaItems.length > 0){
            setVolPgaDropDownVal(pgaWithoutPgaItems[0]);
        }
    }, [pgaWithoutPgaItems])
    return ( 
        <div className="add-voluntary-pga">
            <h2>Voluntary PGA's</h2>
            <h4>Add Voluntary Pga</h4>
            <DropDown
                placeholder='select PGA Type'
                selection
                hidePrefix={true}
                disabled={formDisabled}
                search
                searchInput={{
                    value: volPgaDropDownVal,
                    onChange: (e, { value }) => {
                      setVolPgaDropDownVal(value); 
                    }
                  }}
                className="parts-library-dropdown"
                onChange={(value)=>{
                    pgaDropdownOnChange(value);
                    setVolPgaDropDownVal("");
                }}
                text={volPgaDropDownVal ? "":"Select Pga to Add"}
                data={voluntaryPgaData}
                searchQuery={volPgaDropDownVal}
            />
        </div> 
    );
}
 
export default VoluntryPgas;